import store from "../store";
import { actionTypes } from "./saga";

export function updateCapturePicture(data, navigate) {
  store.dispatch({
    type: actionTypes.UPDATE_CAPTURE_PICTURE,
    payload: { data, navigate }
  });
}

export function revertUpdateCapturePicture(data, navigate) {
  store.dispatch({
    type: actionTypes.REVERT_CAPTURE_PICTURE,
    payload: { data, navigate }
  });
}

export function setCaptures(data) {
  store.dispatch({
    type: actionTypes.SET_CAPTURES,
    payload: { data }
  });
}

export function setOfflineCaptures(data) {
  store.dispatch({
    type: actionTypes.SET_OFFLINE_CAPTURES,
    payload: { data }
  });
}

export function getReferenceImage(data) {
  store.dispatch({
    type: actionTypes.GET_REFERENCE_IMAGE,
    payload: { data }
  });
}
